<template>
  <fragment>
    <v-carousel :show-arrows-on-hover="$vuetify.breakpoint.lgAndUp" :height="$vuetify.breakpoint.smAndDown ? '280' : '400'" class="tmx-carousel" v-model="pictureIndex">
      <v-carousel-item v-for="(slide, index) in pictures" :key="index">
        <v-img :src="require(`../assets/${slide.src}`)" height="100%" contain @click="openPictureDialog(index)"
               style="cursor: pointer;" position="top center"/>
      </v-carousel-item>
    </v-carousel>
    <v-dialog v-model="dialog" max-width="1024" overlay-color="#000000" overlay-opacity="0.9">
      <v-card v-if="$vuetify.breakpoint.mdAndUp">
        <v-carousel :show-arrows-on-hover="$vuetify.breakpoint.lgAndUp" height="576" class="tmx-carousel" v-model="pictureIndex">
          <v-carousel-item v-for="(slide, index) in pictures" :key="index">
            <v-img :src="require(`../assets/${slide.src}`)" height="100%" contain/>
          </v-carousel-item>
        </v-carousel>
      </v-card>
      <v-img :src="require(`../assets/${pictures[pictureIndex].src}`)" width="100%" contain v-else/>
    </v-dialog>
  </fragment>
</template>

<script>
export default {
  name: 'carouselSmall',
  props: {
    pictures: Array,
  },
  data() {
    return {
      dialog: false,
      pictureIndex: 0,
    };
  },
  methods: {
    openPictureDialog(index) {
      this.dialog = true;
      this.pictureIndex = index;
    },
    nextPic() {
      if (this.pictureIndex < this.pictures.length - 1) {
        this.pictureIndex += 1;
      } else {
        this.pictureIndex = 0;
      }
    },
    prevPic() {
      if (this.pictureIndex > 0) {
        this.pictureIndex -= 1;
      } else {
        this.pictureIndex = this.pictures.length - 1;
      }
    },
  },
};
</script>

<style scoped>

</style>
